module.exports = __webpack_public_path__ + "img/en.528ee40a.png";